<script>
    export let blogPath;
    export let titlePic;
    export let title;
    export let blogDate;
    export let firstPara;
</script>

<div  class="blogSummary">
<a href="/blog/{blogPath}">
    <span class="articleImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')" />
    <span>
        <span class="blogTitle">{title}</span>
        <span class="blogDate">{blogDate}</span>
        <span class="blogShortContent">{firstPara}</span>
    </span>
</a>
</div>